module.exports = __webpack_public_path__ + "static/assets/9daec339c84eec409924e2df34a70436.png";